import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const CompoundRuleOfThreeCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [a, setA] = useState('2');
  const [b, setB] = useState('10');
  const [c, setC] = useState('5');
  const [d, setD] = useState('25');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const A = parseFloat(parseBrazilianNumber(a)) || 1;
    const B = parseFloat(parseBrazilianNumber(b)) || 0;
    const C = parseFloat(parseBrazilianNumber(c)) || 1;
    const D = parseFloat(parseBrazilianNumber(d)) || 0;

    // Exemplo: se 2 pessoas (A) produzem 10 itens (B) em 5 dias (C)...
    // Quantos itens (X) 25 pessoas (D) produzem no mesmo tempo? (Modelo simplificado)
    const x = (B * D) / A;

    const res = { x };
    setResultState(res);
    onResultChange([
      { label: 'Resultado (X)', value: x.toLocaleString('pt-BR', { maximumFractionDigits: 2 }) }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <FormField label="Grandeza A1" value={a} onChange={setA} required isNumeric type="text" />
          <FormField label="Grandeza B1" value={b} onChange={setB} required isNumeric type="text" />
          <FormField label="Grandeza A2" value={d} onChange={setD} required isNumeric type="text" />
          <FormField label="X (Resultado)" value="?" onChange={() => { }} />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Regra de 3
          </button>
        </div>

        {resultState && (
          <ResultCard title="Resultado (X)" value={resultState.x.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} color="indigo" />
        )}
      </div>

      <EducationalBlock
        title="Regra de Três"
        tips={[
          'Use para encontrar um valor desconhecido em proporções',
          'Grandezas diretamente proporcionais: quando uma aumenta, a outra também aumenta',
          'Grandezas inversamente proporcionais: quando uma aumenta, a outra diminui',
          'Esta versão resolve o problema básico de proporção'
        ]}
      />
    </div>
  );
};

export default CompoundRuleOfThreeCalculator;
